/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */
export default angular.module('tektelic.components.confirmOnExit', [])
    .directive('tkConfirmOnExit', ConfirmOnExit)
    .name;

/*@ngInject*/
function ConfirmOnExit($state, $mdDialog, $window, $filter) {
    return {
        link: function ($scope) {

            $window.onbeforeunload = function () {
                if (($scope.confirmForm && $scope.confirmForm.$dirty) || $scope.isDirty) {
                    return $filter('translate')('confirm-on-exit.message');
                }
            }
            $scope.$on('$stateChangeStart', function (event, next, current, params) {
                if (($scope.confirmForm && $scope.confirmForm.$dirty) || $scope.isDirty) {
                    event.preventDefault();
                    var confirm = $mdDialog.confirm()
                        .title($filter('translate')('confirm-on-exit.title'))
                        .htmlContent($filter('translate')('confirm-on-exit.html-message'))
                        .ariaLabel($filter('translate')('confirm-on-exit.title'))
                        .cancel($filter('translate')('action.cancel'))
                        .ok($filter('translate')('action.ok'));
                    $mdDialog.show(confirm).then(function () {
                        if ($scope.confirmForm) {
                            $scope.confirmForm.$setPristine();
                        } else {
                            $scope.isDirty = false;
                        }
                        $state.go(next.name, params);
                    }, function () {
                    });
                }
            });
        },
        scope: {
            confirmForm: '=',
            isDirty: '='
        }
    };
}


// WEBPACK FOOTER //
// ./src/app/components/confirm-on-exit.directive.js